import { useState } from "react";
import "./Hero.css";
import Modal from "../Modal/Modal";

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEarlyAccess = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <section className="hero">
        <div className="hero__container">

          {/* Badge */}
          <div className="hero__badge">
            <span className="hero__badge-dot"></span>
            <span>Coming Soon - Join the Early Access</span>
          </div>

          {/* Heading */}
          <h1 className="hero__title">
            The command center for
            <br />
            influencer marketing
          </h1>

          {/* Description */}
          <p className="hero__description">
            Brief to ROI in one platform. No more scattered spreadsheets,
            lost approvals, or manual reporting across tools.
          </p>

          {/* CTA */}
          <button
            type="button"
            className="hero__button"
            onClick={handleEarlyAccess}
          >
            Get Early Access
          </button>

        </div>
      </section>

      {/* Waitlist Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Hero;